<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper p-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="not_ib">
                        <div class="text-center">
                            <img src="../../assets/image/pending_ib.svg" alt="" class="pending_ib">
                            <h3 class="title">Ooppsss....</h3>
                            <p class="desc">You are not eligible to become an Account Manager.</p>
                            <div class="option_btn">
                                <router-link to="/introduction-broker/type" class="btn btn_red mb-3 mt-4">Join Now</router-link>
                                <router-link to="/" class="btn btn_outline_grey">Go To Dashboard</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DashHeader from "../../layouts/Header.vue";
// import DashFooter from "../../layouts/Footer.vue";
import Sidebar from "../../layouts/Sidebar.vue";

// import swal from 'sweetalert'
// import axios from "axios";

export default {
    name: "Dashboard",
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
    },

}
</script>

<style scoped>
img.pending_ib{
  width: 40%;
  display: block;
  margin: 0 auto;
}
.loading{
  height: calc(100vh - 100px);
}
.not_ib{
  height: calc(100vh - 60px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.not_ib .title{
  font-weight: 700;
  color: var(--red);
}
.not_ib .option_btn .btn{
  display: block;
  width: 200px;
  margin: 0 auto;
}

.boxes .box__info{
  border: 1px solid #b5b5b5;
  border-radius: 14px;
  padding: 14px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
  height: 120px;
}
.boxes .box__info .box__heading{
  display: flex;
  align-items: flex-start;
}
.boxes .box__info .box__heading .rect{
  width: 16px;
  height: 16px;
  border-radius: 5px;
  background: #005995;
  margin-right: 10px;
  margin-top: 2px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.boxes .box__info .box__heading .title{
  font-weight: 700;
  font-size: 12pt;
  color: var(--darkGrey) !important;
}
.boxes .box__info .box__body{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.boxes .box__info .box__body .text{
  font-weight: 700;
  font-size: 24pt;
  margin: 0;
}
.boxes .box__info .box__body .text_type{
  font-weight: 700;
  font-size: 16pt;
  margin: 0;
}
.boxes .box__info .box__body .link{
  font-weight: 700;
  font-size: 22pt;
  margin-left: 5px;
  color: #005995;
}
</style>